<template>
  <GithubRepo />
</template>
<script>
import GithubRepo from "./GithubRepo.vue";
export default {
  name: "VuewerBase",
  components: { GithubRepo },
};
</script>
